import qs from 'qs';
import { useQuery } from 'react-query';
import { network } from 'services/network';

import { QueryKeys } from 'api/queryKeys';

const queryFn = (params) => {
    const querystring = qs.stringify({ ...params }, { addQueryPrefix: true, skipNulls: true, arrayFormat: 'comma' });
    const url = `api/bo/getTaskDataByHashCode${querystring}`;
    return network.get<QueryFnResponse[]>(url).then((response) => response.data);
};

export const useQueryGetTaskDataByHashCode = (params: QueryParams) => {
    return useQuery<QueryFnResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getTaskDataByHashCode', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId) && Boolean(params.hashCodesList && params.hashCodesList.length > 0),
        staleTime: 0,
        cacheTime: 0,
    });
};

export const useQueryGetTaskDataByHashCodeSearch = (params: QueryParams) => {
    return useQuery<QueryFnResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getTaskDataByHashCodeSearch', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
        staleTime: 0,
        cacheTime: 0,
    });
};

interface QueryParams {
    metaDataId: number;
    hashCodesList?: string[];
    filter?: string;
}

interface QueryFnResponse {
    activityId: string;
    metaDataId: number;
    name: string;
    taskId: number;
    taskVersionHashCode: string;
}

type QueryResponse = QueryFnResponse & {};
